import { IFRAME_HOST } from 'ui-addon-iframeable/messaging/IFrameControlMessage';
import { getLocalSetting } from './LocalEnv';
import type { AnyMessage } from '../types';

const MSG_SENT = 'SENT';
const MSG_RECEIVED = 'RECEIVED';
const IFRAME_EMBED = 'EMBED';

const debugEnabled = (name: string): boolean =>
  !!getLocalSetting(name, 'debug');

const toMessage = (name: string, message: string): string =>
  `[iframeable ${name}] ${message}`;

const logMessage = (
  name: string,
  source: string,
  direction: string,
  message: AnyMessage
): void => {
  if (debugEnabled(name)) {
    console.log(toMessage(name, `${source} ${direction}`), message);
  }
};

const logError = (
  name: string,
  source: string,
  error: string,
  ...args: any[]
): void => {
  if (debugEnabled(name)) {
    console.error(toMessage(name, source), error, ...args);
  }
};

export const logHostError = (
  name: string,
  error: string,
  ...args: any[]
): void => logError(name, IFRAME_HOST, error, ...args);

export const logEmbedError = (
  name: string,
  error: string,
  ...args: any[]
): void => logError(name, IFRAME_EMBED, error, ...args);

export const logHostMessageSent = (name: string, message: AnyMessage): void =>
  logMessage(name, IFRAME_HOST, MSG_SENT, message);

export const logHostMessageReceived = (
  name: string,
  message: AnyMessage
): void => logMessage(name, IFRAME_HOST, MSG_RECEIVED, message);

export const logEmbedMessageSent = (name: string, message: AnyMessage): void =>
  logMessage(name, IFRAME_EMBED, MSG_SENT, message);

export const logEmbedMessageReceived = (
  name: string,
  message: AnyMessage
): void => logMessage(name, IFRAME_EMBED, MSG_RECEIVED, message);
